/**
 * useIsUsAccount — true only when the signed-in user's account country
 * is US. Drives per-storefront App Store compliance: external payment
 * link-outs are allowed on the US storefront (3.1.1 US allowance) but
 * not elsewhere, so non-US users must never see them.
 * Defaults to false (hidden) until confirmed.
 */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function useIsUsAccount() {
  const { user } = useAuth() || {};
  const [isUS, setIsUS] = useState(false);
  useEffect(() => {
    if (!user) { setIsUS(false); return; }
    let cancelled = false;
    api.get("/auth/me")
      .then((r) => { if (!cancelled) setIsUS(r.data?.country === "US"); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [user]);
  return isUS;
}
